import { GridCellParams } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import React from 'react';

interface XGridIconCellProps {
  icon: string | JSX.Element;
  alt?: string;
  align?: string;
  onClick?: (params: GridCellParams, event) => void;
  hasTitle?: boolean;
  getTitle?: (params: GridCellParams) => any;
  disabled?: boolean;
}

/**
 * Cell renderer to display an icon, either an imported icon, or a react component
 * @param params X-Grid Params: `GridCellParams`
 * @returns JSXElement
 */
export const XGridIconCell =
  ({ icon, alt = '', align = 'center', onClick, hasTitle = false, getTitle, disabled = false }: XGridIconCellProps) =>
  (params: GridCellParams) => {
    return (
      <React.Fragment>
        <div
          style={{
            justifyItems: align,
            width: '100%',
            pointerEvents: disabled ? 'none' : 'auto',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          <Box onClick={e => onClick?.(params, e)}>
            {typeof icon === 'string' && <img style={{ justifySelf: align }} src={icon} alt={alt} />}
            {typeof icon !== 'string' && icon}
            {hasTitle && getTitle(params)}
          </Box>
        </div>
      </React.Fragment>
    );
  };
